<div class="month-page">
<div class="container month">
    @if (!error) {
        <div class="month-shell">
            <div class="header month-card">
                <button (click)="navigateBack()" class="navigation-button" type="button" [attr.aria-label]="'ALT.MONTH_BACK' | translate">
                    <img alt="" class="navigation"
                      src="assets/images/month/left.svg">
                </button>
                <h1 class="title">{{ currentMonth | monthYear }}</h1>
                <button (click)="navigateForward()" class="navigation-button" type="button" [attr.aria-label]="'ALT.MONTH_NEXT' | translate">
                    <img alt="" class="navigation"
                      src="assets/images/month/right.svg">
                </button>
            </div>
            <div class="calendar-container month-card">
                <div class="days">
                    <p class="day">{{ 'MONTH.MONDAY' | translate }}</p>
                    <p class="day">{{ 'MONTH.TUESDAY' | translate }}</p>
                    <p class="day">{{ 'MONTH.WEDNESDAY' | translate }}</p>
                    <p class="day">{{ 'MONTH.THURSDAY' | translate }}</p>
                    <p class="day">{{ 'MONTH.FRIDAY' | translate }}</p>
                    <p class="day">{{ 'MONTH.SATURDAY' | translate }}</p>
                    <p class="day">{{ 'MONTH.SUNDAY' | translate }}</p>
                </div>
                <div class="calendar">
                    @for (week of month; track week) {
                        <div class="calendar-item">
                            @for (day of week; track day) {
                                <div (click)="navigateToDay(day)" [matTooltip]="getDayToolTip(day)"
                                     [ngClass]="
                            !isInCurrentMonth(day) ? 'bg-other-month' :
                            isCurrentDay(day) ? 'bg-current-day' :
                            ''"
                                     class="day"
                                >
                                    <p [ngClass]="!isInCurrentMonth(day) ? 'text-other-month' : ''">{{ day | weekday }}</p>
                                    <div class="day-images">
                                        @if (getDayImages(day); as images) {
                                            <img [ngClass]="!isInCurrentMonth(day) ? 'img-other-month' : ''" class="day-img"
                                                 [src]="images.sign"/>
                                            <img [ngClass]="!isInCurrentMonth(day) ? 'img-other-month' : ''" class="day-img"
                                                 [src]="images.moon"/>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
            <div class="legend month-card">
                <h2>{{ 'MONTH.LEGEND' | translate }}</h2>
                <div class="legend-grid">
                    <div class="legend-panel moon-panel">
                        <h3 class="legend-title moon-title">
                            <span class="legend-line"></span>
                            <span class="legend-title-text">{{ 'MONTH.MOON_PHASES' | translate }}</span>
                            <span class="legend-line"></span>
                        </h3>
                        <div class="moon-list">
                            @for (item of moonLegendItems; track item.key) {
                                <div class="legend-item moon-item">
                                    <div class="moon-icons">
                                        @for (phaseId of item.phaseIds; track phaseId) {
                                            <img alt="{{'PHASE.' + phaseId | translate }}"
                                                 src="assets/images/moon/moon_{{phaseId}}.webp"/>
                                        }
                                    </div>
                                    <p>{{ 'PHASE.' + item.phaseIds[0] | translate }}</p>
                                </div>
                            }
                        </div>
                    </div>
                    <div class="legend-panel sign-panel">
                        <h3 class="legend-title sign-title">
                            <span class="legend-line"></span>
                            <span class="legend-title-text">{{ 'MONTH.ZODIAC_SIGNS' | translate }}</span>
                            <span class="legend-line"></span>
                        </h3>
                        <div class="sign-grid">
                            @for (signId of zodiacSigns; track signId) {
                                <div class="legend-item sign-item">
                                    <img alt="{{'SIGN.' + signId.toUpperCase() | translate }}"
                                         src="{{getImageForSign(signId)}}"/>
                                    <p>{{ 'SIGN.' + signId.toUpperCase() |  translate }}</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    @if (error) {
        <div>
            <app-error></app-error>
        </div>
    }
</div>
</div>
